module.exports = __webpack_public_path__ + "static/img/Post shore 2.0 meter.aff7cce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Post shore 2.0 meter.jpg
// module id = 95
// module chunks = 1